// @ts-nocheck
import React from "react";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import StandardDetailLayout from "@/layouts/StandardDetailLayout";
import { trpcClient } from "@/lib/trpc";
import { QCMaterialForm } from "./QCMaterialForm";

export default function QCMaterialCreate() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const searchParams = useSearch({ strict: false }) as any;

  const initialData = {
    materialId: searchParams?.materialId || "",
    vendorId: searchParams?.vendorId || "",
    purchaseOrderId: searchParams?.purchaseOrderId || "",
    receiptDocId: searchParams?.receiptDocId || "",
    materialCategory: searchParams?.materialCategory || undefined,
    batchNumber:
      searchParams?.batchNumber ||
      (searchParams?.poCode ? `LOT-${searchParams.poCode}` : ""),
    quantity:
      Number(
        searchParams?.pendingQty ||
          searchParams?.qtyReceived ||
          searchParams?.orderedQty
      ) || 1000,
    unit: searchParams?.unit || "Tờ",
  };

  const handleSubmit = async (data: any) => {
    try {
      const created = await (trpcClient as any).qcMaterials.create.mutate(data);
      toast.success("Tạo biên bản kiểm tra vật tư đầu vào (IQC) thành công!");
      await queryClient.invalidateQueries({ queryKey: ["qcMaterials"] });
      await queryClient.invalidateQueries({ queryKey: ["qc-materials-all"] });
      await queryClient.invalidateQueries({ queryKey: ["pending-iqc-queue"] });
      navigate({
        to: "/qc-materials/$checkId",
        params: { checkId: created.id },
        replace: true,
      });
    } catch (err: any) {
      toast.error(err?.message || "Lỗi khi tạo phiếu IQC");
      throw err;
    }
  };

  return (
    <StandardDetailLayout
      breadcrumbs={[
        { label: "Kiểm tra Vật tư (IQC)", to: "/qc-materials" },
        { label: "Lập biên bản IQC mới" },
      ]}
      title="Lập Biên Bản IQC"
      onBack={() => navigate({ to: "/qc-materials" })}
      actions={
        <div className="flex items-center gap-2">
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => navigate({ to: "/qc-materials" })}
          >
            Hủy
          </Button>
          <Button
            type="submit"
            size="sm"
            className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold"
            onClick={() => {
              const formEl = document.getElementById("qc-material-canonical-form") as HTMLFormElement | null;
              formEl?.requestSubmit();
            }}
          >
            <Save className="w-4 h-4 mr-1.5" /> Lưu Biên Bản IQC
          </Button>
        </div>
      }
    >
      <QCMaterialForm
        initialData={initialData}
        onSubmit={handleSubmit}
        onCancel={() => navigate({ to: "/qc-materials" })}
      />
    </StandardDetailLayout>
  );
}
